import React, { useState } from 'react';
import SettingsRestDataProvider from '../../../data/SettingsRestDataProvider';
import PopupDialog from '../../common/PopupDialog/PopupDialog';
import SubsectionPanel from '../../common/SubsectionPanel/SubsectionPanel';
import InfoPanel from '../../common/InfoPanel/InfoPanel';
import { useTranslation } from 'react-i18next';

const ResetSettingsTab: React.FC = () => {
  const { t } = useTranslation(['common', 'screens']);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const provider = React.useMemo(() => new SettingsRestDataProvider(), []);

  const handleReset = async () => {
    setLoading(true);
    setMessage(null);
    setError(null);
    try {
      const result = await provider.resetSettings();
      setMessage(result.message || t('screens:resetSettings.resetSuccess'));
    } catch (err: any) {
      setError(err.message || t('screens:resetSettings.resetFailed'));
    } finally {
      setLoading(false);
      setConfirmOpen(false);
    }
  };

  return (
    <div>
      <SubsectionPanel title={t('screens:resetSettings.title')}>
        {error && <div style={{ color: 'red', marginBottom: 12 }}>{error}</div>}
        <InfoPanel header="Resetting your tenent">
          This action will reset your entire tenant, including all data and settings. It cannot be undone. Use this only if you want to start fresh with a clean database.
          Make sure to back up any important data before proceeding.
        </InfoPanel>

        <button className="btn btn-danger" style={{ "margin" : "0.5em"}} onClick={() => setConfirmOpen(true)} disabled={loading}>
          {loading ? t('screens:resetSettings.resetting') : t('screens:resetSettings.resetDatabase')}
        </button>
        {message && <div style={{ color: 'green', marginTop: 16 }}>{message}</div>}
        {error && <div style={{ color: 'red', marginTop: 16 }}>{error}</div>}
        <PopupDialog
          open={confirmOpen}
          title={t('screens:resetSettings.confirmReset')}
          onClose={() => setConfirmOpen(false)}
          actions={
            <>
              <button className="btn btn-outline-secondary" onClick={() => setConfirmOpen(false)} disabled={loading}>{t('common:cancel')}</button>
              <button className="btn btn-danger" onClick={handleReset} disabled={loading} style={{ marginLeft: 12 }}>
                {loading ? t('screens:resetSettings.resetting') : t('screens:resetSettings.yesReset')}
              </button>
            </>
          }
        >
        <p>{t('screens:resetSettings.confirmResetMessage')}</p>
      </PopupDialog>
      </SubsectionPanel>
    </div>
  );
};

export default ResetSettingsTab;
